import { createNode } from '@glueapp/graph-types';

export const RespondToApiStream = createNode({
    id: 'RespondToApiStream',
    name: 'Respond to API (Stream)',
    description: 'Send a streaming response back to an API request',
    category: 'API Server',
    color: '#808080',
    version: 1,
    inPorts: {
        Data: { kind: 'object', properties: {}, restriction: 'open' },
        Event: { kind: 'string' },
        'Is Final': { kind: 'boolean' },
    },
    optionalInPorts: ['Event'],
    outPorts: {},
    execute: input => {
        // @ts-expect-error - contexts not in createNode type
        const contexts = input.contexts as Record<string, unknown> | undefined;
        const apiEndpoint = contexts?.apiEndpoint as { requestId: string } | undefined;
        const requestId = apiEndpoint?.requestId;

        const data = input.inPorts.Data;
        const event = input.inPorts.Event;
        const isFinal = input.inPorts['Is Final'] as boolean;

        return {
            output: {},
            apiResponse: {
                requestId: requestId || '',
                statusCode: 200,
                body: { data, event },
                streaming: true,
                isFinal,
            },
        };
    },
});
